import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

const ArrowUpShape = ({
    title,
    titleId = "tm-icon-arrowUpShape",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg width="1em" height="1em" viewBox="0 0 10 10" aria-hidden={!title} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fill="#333" d="M5 .757L9.243 5l-.943.943-3.3-3.3-3.3 3.3L.757 5z" />
    </svg>
);

export default ArrowUpShape;
